module.exports = __webpack_public_path__ + "static/media/34.ff8b13a6.jpg";